import React from 'react';
import PropTypes from 'prop-types';
import Body from '../Components/layout/Body';

const CHOICES_INTRO_HELP = `
  <div>
    <p><strong>Purpose: </strong>In the Make some choices section, you’ll review Your Prospects to see if you want to move some into Your Picks. 
    Or conversely remove any Prospects that haven’t worked well for the client.  
    </p>
    <p>
    This is just a handy way of sorting through what you’ve Test-driven so far.  
    </p>
  </div>
`;

const propTypes = {
  firstName: PropTypes.string,
  pronouns: PropTypes.arrayOf(PropTypes.string),
  onContinue: PropTypes.func.isRequired
};

const defaultProps = {
  firstName: 'the client',
  pronouns: ['they', 'them', 'their'],
};

//content sub-component with unique content for this page
function ReviewTabChooseIntroContent(props) {

  return(
    <>
    <p><strong>Prospects</strong> are access method setups that you’ve tried and are still considering.  
          As soon as you start a Test-drive with an access method, that access method automatically becomes a Prospect.</p>
    <p>Let's review these to see if you're ready to recommend any solutions or remove any that haven't worked well.</p>
    </>
  );
}

//main component for this page
//basic pattern is to set up the pageData, define the unique content for the page (above),
//then render the page using <Body> component
function ReviewTabChooseIntro(props) {
  const onContinue = props.onContinue;

  const pageData = {
    image: "",
    faIcon: "",
    pageSymbolClassName: "aa-section-symbol review",
    title: `Now let's make some decisions about each of Your Prospects`,
    subTitle: "",
    learnMore: {linkText: "Learn More about Review and decision-making",
                title: "Review and decision-making",
                content: CHOICES_INTRO_HELP
                },
    nextRoute: "", //this is governed by onContinue
    sidebar: false
  }

  console.log("Rendering ReviewTabChooseIntro");
  
  return(
    <>
    <Body page={pageData} 
      contentComponent={<ReviewTabChooseIntroContent/>}
      onContinue={onContinue} 
    />
    </>
  );
}

ReviewTabChooseIntro.propTypes = propTypes;
ReviewTabChooseIntro.defaultProps = defaultProps;

export default ReviewTabChooseIntro;